import {connect} from "react-redux";
import NewsPanel from "./NewsPanel.jsx";

const mapStateToProps = (state) => {
    return {
        sport: state.games.current && state.games.current.sport ? state.games.current.sport : null,
        language: state.user.language
    };
};


const NewsPanelContainer = connect(
    mapStateToProps,
)(NewsPanel);

export default NewsPanelContainer